export default __webpack_public_path__ + "static/media/sapphire6.64b92017.jpg";